import { render, staticRenderFns } from "./StudioEventChip.vue?vue&type=template&id=66ef6afa&scoped=true"
import script from "./StudioEventChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudioEventChip.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StudioEventChip.vue?vue&type=style&index=0&id=66ef6afa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ef6afa",
  null
  
)

export default component.exports